module.exports = __webpack_public_path__ + "static/img/download_app_qrcode.a6462b78.jpg";